/**
* @name: index
* @author: weiyong
* @date: 2023-11-25 20:26
* @description：index
* @update: 2023-11-25 20:26
*/
<template>
  <div class="wh100b xmPageContent" :id="xmPageContentId" :style="[ctlDivStyle,'--backgroundColor:'+(props.ctlBgColor)+'']">
    <div  v-if="showContentFlag" style="position: absolute;z-index: 99;width:100%;justify-content: center;display: flex;">
      <a-empty
        image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
        :image-style="{
      height: '90px',
    }"
      >
        <template #description>
      <span style="color:#666;">
        {{props.noDataContent||'当前无数据，请从左侧选择应用模块！'}}
      </span>
        </template>
      </a-empty>
    </div>

    <a-skeleton active v-if="loadPageFlag"/>
    <main-page pageFrom="xmPageContent" :pModelObj="pModelObj" v-show="!loadPageFlag" @click.stop :pageConfig="pageConfigs"></main-page>
  </div>
</template>

<script lang="ts">
import {defineAsyncComponent, defineComponent} from 'vue';

const componentParam = {
  MainPage: defineAsyncComponent(
    () => import("@/main-page/main-page.vue")
  )
}
export default defineComponent({
  components: {
    ...componentParam
  },
  name: "xmPageContentCtl",
});
</script>

<script lang="ts" setup>
import {Skeleton as ASkeleton} from 'ant-design-vue';
import {useLoading} from "./hooks/useLoading";
import {useLoadDesInfo} from "./hooks/useLoadDesInfo";
import GoingUtils from "@/utils/goingUtils";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useFlowStartHooks} from "@/main-page/simpleFlow/hooks/useFlowStartHooks";
import {
  usePageContentAclHooks
} from "@/main-page-base/ctls/containers/xmPageContent/hooks/usePageContentAclHooks";


interface propTypes {
  readOnlyText: boolean;
  props: any;
  events: any;
  styles: any;
  model: any;
  pModelObj: any;
  elConfig: any;
  outElement: any;
  eventParams: any;
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  readOnlyText: false,
  styles: {},
  events: [],
  props: {},
  pModelObj: {},
  eventParams: {},
  model: {},
  elConfig: {},
  outElement: {},
});
const {elConfig,  props, styles, model, events}: any = toRefs(propsPage);
const {pageLoadingFlag, showLoading} = useLoading();

const columnConfigFlag=unref(props).columnConfigFlag||inject('columnConfigFlag');
const mainPageColConfigCode=unref(props).mainPageColConfigCode||inject('mainPageColConfigCode');
const xmPageContentId=computed(()=>{
  return GoingUtils.getPageCode()+"_"+unref(props).key;
})
if(columnConfigFlag){
  provide('columnConfigFlag',columnConfigFlag);
  provide('mainPageColConfigCode',mainPageColConfigCode);
}else{
  provide('columnConfigFlag',false);
  provide('mainPageColConfigCode','');
}
// 嵌套页不能继承外层 xmForm 的表单上下文。否则父页面的 pageColumnConfig
// 会让无 model 的表格（如选择物料 xmRelQuery）在 getConfigElItem 里读 key 崩溃。
provide('pItemType', '');
provide('formElConfigs', []);
provide('formElAclInfos', null);
provide('formKey', '');
const emits = defineEmits(['closeLoading']);
const {
  showContentFlag,
  clearCache,
  getCurPageDes,
  pageConfigs,
  loadDesInfos,
  loadPageFlag
} = useLoadDesInfo({
  emits,
  events,
  props,
  pageCode: unref(props).pageCode,
  moduleCode: unref(props).moduleCode,
  pageLoadingFlag
});

/**
 * 监听界面变化
 */
watch(() => [unref(props).pageCode, unref(props).moduleCode], (newVal) => {
  clearCache(unref(props).pageCode);
  getCurPageDes(unref(props).pageCode, unref(props).moduleCode);
})

unref(props).isFormEl = false;

//是否可以拖拽
const isPreview = computed(() => {
  if (GoingUtils.getIsPreview()) {
    return true;
  }
  return false;
})


const winParams = ref({});
const {
  initFunctionEngine
} = useFlowStartHooks({
  winParams,
  emits
});

onMounted(() => {
  initFunctionEngine();
})

const {ctlDivStyle} = useCtlStyle({
  styles,
  props,
  outExtendProp: ['width', 'height'],
  componentKey:'xmPageContent',
}, inject('pItemType'));

onMounted(() => {
  (window as any).FunctionEngine.getPageDesInfo = function () {
    return unref(pageConfigs);
  };
})
const ctlAclInfos = inject('ctlAclInfos');
const xmPageContentAcl=ref(null);
usePageContentAclHooks({props,xmPageContentAcl,ctlAclInfos});
provide ( 'ctlAclInfos' , xmPageContentAcl ) ;


</script>

<style type="text/css" lang="less">
.xmPageContent-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.10);
}

.xmPageContent-col-ctl {
  .main-page {
    overflow: hidden;
  }
}
</style>
